module.exports = __webpack_public_path__ + "static/img/11.6df5a37.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/11.png
// module id = Dkeq
// module chunks = 0